import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useNavigate, useParams } from "react-router-dom";
import toastr from "react-redux-toastr";
import PartnerBillSummaryComponent from "./component";

const PartnerBillDetailsContainer = ({ getDataFromAPI }) => {
  const navigate = useNavigate();
  const { franchiseeId, billId } = useParams();
  const [billData, setBillData] = useState(null);
  const [payoutBillData, setPayoutBillData] = useState([])
  const [loading, setLoading] = useState(true);
  const [getFranchiseeId, setGetFranchiseeId] = useState("")
  const [chargeSummery, setChargeSummery] = useState(null);
    const [currentPayoutId, setCurrentPayoutId] = useState(null);

const handlePostBill = () =>{
    navigate(`/home/configuration/partner/bills/post-bills/${getFranchiseeId}`)
  }
const handleMiscCharge = () => {
  navigate(`/home/configuration/partner/bills/miscellaneous-charge`, {
    state: {
      franchiseeId: billData?.franchiseeId, 
      partnerName: billData?.name, 
    },
  });
};


  useEffect(() => {
    fetchBillData();
    fetchPayoutBillData();
  }, [billId]);

  const fetchBillData = () => {
    setLoading(true);
    getDataFromAPI(
      `/partner/api/v3/acc/bills/${billId}/charges`,
      "GET",
      undefined,
      (response) => {
       
        setBillData(response);
        setLoading(false);
        setGetFranchiseeId(response.franchiseeId)
         if (response.length > 0) {
            setCurrentPayoutId(response[0].payoutId);
          }
      },
      (err) => {
        console.error("Error fetching bill:", err.message);
        toastr.error("Error", err.message)
        setLoading(false);
      }
    );
  };
  const fetchChargeBillSummery = (payoutId) => {
      if (!payoutId) {
        toastr.warning("Warning", "No payout ID available");
        return;
      }
      
      setLoading(true);
      getDataFromAPI(
        `/partner/api/v3/acc/payout/${payoutId}/deduction`,
        'GET',
        undefined,
        (response) => {
          setChargeSummery(response);
          setLoading(false);
        },
        (err) => {
          console.error("API Error:", err);
          toastr.error(err.message || "Error", "Failed to load charge summary");
          setLoading(false);
        }
      );
    };
   const fetchPayoutBillData = () => {
    setLoading(true);
    getDataFromAPI(
      `/partner/api/v3/acc/bill/${billId}/payout`,
      "GET",
      undefined,
      (response) => {
       console.log("payout response", response)
        setPayoutBillData(response);
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching bill:", err.message);
        toastr.error("Error", err.message)
        setLoading(false);
      }
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const handleGoBack = () => navigate(-1);

  return (
    <PartnerBillSummaryComponent
      loading={loading}
      billData={billData}
      payoutBillData={payoutBillData}
      onGoBack={handleGoBack}
      handleMiscCharge={handleMiscCharge}
      handlePostBill={handlePostBill}
      fetchChargeBillSummery={fetchChargeBillSummery}
      chargeSummery={chargeSummery}

    />
  );
};

export default connect(null, { getDataFromAPI })(PartnerBillDetailsContainer);
